import React, {useCallback} from 'react';

import Group from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';
import IconButton from '@pb/kit-component-icon-button';
import {Input} from '@pb/kit-component-input-v2';
import Label from '@pb/kit-component-label';
import {Status, usePushNotification} from '@pb/kit-component-push-notification';

import {fieldRow, helperText as helperTextStyle, requiredMarker} from '../confirm-login-fields.module.styl';

type FieldMappingRowProps = {
    label: string,
    value: string,
    required?: boolean,
    helperText?: string,
    onCopy?: () => void,
};

export const FieldMappingRow: React.FC<FieldMappingRowProps> = ({label, value, required, helperText, onCopy}) => {
    const {onCreateNote} = usePushNotification();

    const handleCopy = useCallback(() => {
        onCopy?.();

        if (navigator?.clipboard?.writeText) {
            navigator.clipboard.writeText(value)
                .then(() => {
                    onCreateNote({
                        message: `"${label}" copied to your clipboard`,
                        id: `copy-field-${Date.now()}`,
                        status: Status.SUCCESS,
                        autoHideTimeout: 2000,
                    });
                })
                .catch(() => {});
        }
    }, [onCreateNote, value, label, onCopy]);

    return (
        <Group direction="v" gap="xs" className={fieldRow}>
            <Label>
                {label}
                {required ? <span className={requiredMarker}> *</span> : null}
            </Label>
            <Input
                readOnly={true}
                value={value}
                disabled={true}
                endAdornment={(
                    <IconButton
                        style={{width: 30, minWidth: 30, height: 30}}
                        onClick={handleCopy}
                        iconProps={{type: Icons.COPY, size: 'Size_14'}}
                    />
                )}
            />
            {helperText != null ? (
                <span className={helperTextStyle}>{helperText}</span>
            ) : null}
        </Group>
    );
};
